import { GET_DATA_HISTORY_REPORT } from "../../appointment-internal/management/AppointmentConsultationProcess/queries";
export default async function getDataAppointmentHistoryReport(where, client) {
  try {
    const { data: { getDataHistoryReport } = {} } = await client.query({
      query: GET_DATA_HISTORY_REPORT,
      fetchPolicy: "network-only",
      variables: {
        where,
      },
    });
    return getDataHistoryReport || [];
  } catch (error) {
    throw new Error(error.message);
  }
}
